import { Link } from "react-router-dom";

import { downloadUrlsFor } from "../api/updates";
import { ReleaseNotes } from "../components/ReleaseNotes";
import { useLatestRelease, useReleases } from "../useReleases";

export function Releases() {
  const releases = useReleases();
  const latestVersion = releases[0]?.version ?? "";
  // Only the newest entry shows its notes inline, so it's the only body this
  // page needs; the rest link through to their own page.
  const { release: latest } = useLatestRelease();
  // The list and the latest-release fetch resolve independently, so they can
  // briefly disagree about which version is newest. Rendering notes under a
  // heading they don't belong to would be worse than rendering none, so the
  // body is shown only once both agree.
  const latestBody = latest && latest.version === latestVersion ? latest.body : null;

  return (
    <>
      <section className="page-banner page-banner--releases marketing__bleed">
        <div className="page-header bleed-inner">
          <h1>Releases</h1>
          <p className="muted">
            Every version, with what changed. Windows SmartScreen may warn on first
            run — the installers are signed for the auto-updater, but not yet with
            a Windows Authenticode certificate. Choose "More info" → "Run anyway".
          </p>
        </div>
      </section>

      <div className="release-list">
        {releases.map((release, i) => {
          const { nsisUrl, msiUrl } = downloadUrlsFor(release.version);
          const isLatest = i === 0;
          return (
            <section className="panel release-entry" key={release.version} id={release.version}>
              <div className="release-entry__header">
                <h2>
                  <Link to={`/releases/${release.version}`}>v{release.version}</Link>{" "}
                  {isLatest && <span className="badge badge--healthy">Latest</span>}
                </h2>
                <span className="muted">{release.date}</span>
              </div>
              <p className="release-entry__headline">{release.headline}</p>

              {isLatest && latestBody ? (
                <ReleaseNotes body={latestBody} />
              ) : (
                <p className="muted">
                  {!isLatest && (
                    <>
                      Superseded by <Link to={`/releases/${latestVersion}`}>v{latestVersion}</Link>.{" "}
                    </>
                  )}
                  <Link to={`/releases/${release.version}`}>Full notes →</Link>
                </p>
              )}

              <div className="download__actions">
                <a className="button" href={nsisUrl}>
                  Installer (.exe)
                </a>
                <a className="button" href={msiUrl}>
                  MSI
                </a>
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
